export default "__VITE_ASSET__CfvWgE$u__"